import React from "react";

function IconArrowRight(data) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={data.w}
        height={data.h}
        viewBox="0 0 38.44 24.543"
      >
        <g transform="translate(.01)">
          <path
            fill="none"
            stroke="#b8b8b8"
            strokeMiterlimit="10"
            strokeWidth="3"
            d="M0 12.5l35-.23"
            data-name="Stroke 10"
          ></path>
          <path
            fill="#b8b8b8"
            d="M2.047 24.543L0 22.344l10.838-10.071L0 2.2 2.047 0l13.2 12.273z"
            data-name="Fill 12"
            transform="translate(23.186)"
          ></path>
        </g>
      </svg>
    );
  }

export default IconArrowRight;
